module.exports = __webpack_public_path__ + "static/media/Degular-Medium.789d2d8a.ttf";